<!-- 框架布局 -->
<template>
  <ele-pro-layout
    class="app-container"
    :menus="menus"
    :home-title="homeTitle"
    :project-name="''"
    :show-setting.sync="showSetting"
    :need-setting="enableSetting"
    :hide-sidebars="hideSidebars"
    :repeatable-tabs="repeatableTabs"
    :tabs="theme.tabs"
    :color="theme.color"
    :collapse="theme.collapse"
    :head-style="theme.headStyle"
    :side-style="theme.sideStyle"
    :layout-style="theme.layoutStyle"
    :side-menu-style="theme.sideMenuStyle"
    :fixed-body="theme.fixedBody"
    :fixed-header="theme.fixedHeader"
    :fixed-sidebar="theme.fixedSidebar"
    :body-full="theme.bodyFull"
    :show-footer="theme.showFooter"
    :colorful-icon="theme.colorfulIcon"
    :showBreadcrumb="false"
    :logo-auto-size="theme.logoAutoSize"
    :side-unique-open="theme.sideUniqueOpen"
    :show-tabs="false"
    :tab-style="theme.tabStyle"
    :dark-mode="theme.darkMode"
    :weak-mode="theme.weakMode"
    @logo-click="onLogoClick"
    @reload-page="reloadPage"
    @update-screen="updateScreen"
    @update-collapse="updateCollapse"
    @tab-add="tabAdd"
    @tab-remove="tabRemove"
    @tab-remove-all="tabRemoveAll"
    @tab-remove-left="tabRemoveLeft"
    @tab-remove-right="tabRemoveRight"
    @tab-remove-other="tabRemoveOther"
    @change-style="changeStyle"
    @change-color="changeColor"
    @change-dark-mode="changeDarkMode"
    @change-weak-mode="changeWeakMode"
    @set-home-components="setHomeComponents"
    @reset-setting="resetSetting"
    :class="loginType == 3 ? 'hideLeftBar' : ''"
  >
    <template slot="logo">
      <img
        v-if="appTheme == 'furCarer'"
        src="@/assets/images/common/furcarer.png"
      />
      <img v-else src="@/assets/images/common/hippo.png" />
    </template>
    <!-- 顶栏右侧区域 -->
    <template slot="right">
      <ele-header-right
        :setting="enableSetting"
        @item-click="onItemClick"
        @change-language="changeLanguage"
        @showSet-click="showSet = true"
      />
    </template>

    <template v-slot:left>
      <div v-if="loginType != 3">
        <div class="custom__tool-item" @click="updateCollapse(!theme.collapse)">
          <span class="collapseIcon"></span>
          <p>{{
            theme.collapse ? $t('layout.collapseDown') : $t('layout.collapseUp')
          }}</p>
        </div>
      </div>
      <div>
        <div class="custom__tool-item" @click="reloadPage">
          <span class="refreshIcon"></span>
          <p>{{ $t('layout.refresh') }}</p>
        </div>
      </div>
      <div style="display: none">
        <div class="custom__tool-item" @click="$router.push('/home')">
          <span class="homeIcon"></span>
          <p>{{ $t('layout.backHome') }}</p>
        </div>
      </div>
      <div>
        <div class="custom__tool-item" @click="toHelpCenter">
          <span class="helpIcon"></span>
          <p>{{ $t('layout.helpCenter') }}</p>
        </div>
      </div>
      <div>
        <div class="custom__tool-item" @click="changeFullscreen">
          <span class="fullscreenIcon"></span>
          <p>{{ $t('layout.fullScreen') }}</p>
        </div>
      </div>
    </template>
    <system-set-com :showSet.sync="showSet" />
    <!-- 修改密码弹窗 -->
    <!-- <ele-password :visible.sync="showPassword" /> -->
  </ele-pro-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import EleHeaderRight from './components/header-right';
  import SystemSetCom from '@/components/SystemSet/index.vue';
  import { USER_LOGIN_TYPE } from '@/config/setting';
  // import ElePassword from './components/password';
  import {
    HIDE_SIDEBARS,
    REPEATABLE_TABS,
    HOME_TITLE,
    ENABLE_SETTING
  } from '@/config/setting';
  import {
    addPageTab,
    removePageTab,
    removeAllPageTab,
    removeLeftPageTab,
    removeRightPageTab,
    removeOtherPageTab,
    reloadPageTab
  } from '@/utils/page-tab-util';

  export default {
    name: 'EleLayout',
    components: {
      EleHeaderRight,
      SystemSetCom
      // ElePassword
    },
    data() {
      return {
        // 主题
        appTheme: process.env.VUE_APP_THEME || 'furCarer',
        // 是否显示修改密码弹窗
        showPassword: false,
        // 是否显示主题设置抽屉
        showSetting: false,
        // 是否是全屏状态
        fullscreen: false,
        // 项目名
        // projectName: process.env.VUE_APP_NAME,
        projectName: this.$t('home.title'),
        // 顶栏是否显示主题设置按钮
        enableSetting: ENABLE_SETTING,
        // 不显示侧栏的路由
        hideSidebars: HIDE_SIDEBARS,
        // 页签同路由不同参数可重复打开的路由
        repeatableTabs: REPEATABLE_TABS,
        showSet: false, // 设置
        loginType: localStorage.getItem(USER_LOGIN_TYPE) || '2'
      };
    },
    computed: {
      // 主页标题
      homeTitle() {
        // 去掉国际化后直接return HOME_TITLE
        return HOME_TITLE;
      },
      // 菜单数据
      menus() {
        const menus = this.$store.state.user.menus;
        console.log('menus', menus);

        // 国际化
        menus.forEach((menu) => {
          menu.meta.title = this.i18n(menu.path, menu.key, menu);
          if (menu.children) {
            menu.children.forEach((child) => {
              child.meta.title = this.i18n(child.path, child.key, child);
            });
          }
        });

        return menus;
      },
      // 主题状态
      ...mapGetters(['theme'])
    },
    methods: {
      /* 顶栏右侧点击 */
      onItemClick(key) {
        if (key === 'password') {
          // this.showPassword = true;
        } else if (key === 'setting') {
          this.showSetting = true;
        }
      },
      /* 全屏切换 */
      changeFullscreen() {
        try {
          this.fullscreen = this.$util.toggleFullscreen();
        } catch (e) {
          this.$message.error(this.$t('common.notSupport'));
        }
      },
      /* logo点击事件 */
      onLogoClick(isHome) {
        if (!isHome) {
          this.$router.push('/');
        }
      },
      /** 帮助中心 */
      toHelpCenter() {
        this.$message.warning(this.$t('home.helpCenterTip'));
      },
      /* 刷新页签 */
      reloadPage() {
        location.reload(true);
        // reloadPageTab();
      },
      /* 添加tab */
      tabAdd(value) {
        addPageTab(value);
      },
      /* 移除tab */
      tabRemove(obj) {
        removePageTab(obj.name, obj.active);
      },
      /* 移除全部tab */
      tabRemoveAll(active) {
        removeAllPageTab(active);
      },
      /* 移除左边tab */
      tabRemoveLeft(value) {
        removeLeftPageTab(value);
      },
      /* 移除右边tab */
      tabRemoveRight(value) {
        removeRightPageTab(value);
      },
      /* 移除其它tab */
      tabRemoveOther(value) {
        removeOtherPageTab(value);
      },
      /* 更新collapse */
      updateCollapse(value) {
        this.$store.dispatch('theme/set', { key: 'collapse', value: value });
      },
      /* 更新屏幕尺寸 */
      updateScreen() {
        this.$store.dispatch('theme/updateScreen');
        this.fullscreen = this.$util.isFullscreen();
      },
      /* 重置设置 */
      resetSetting() {
        this.$store.dispatch('theme/resetSetting');
      },
      /* 切换主题风格 */
      changeStyle(value) {
        this.$store.dispatch('theme/set', value);
      },
      /* 切换主题色 */
      changeColor(value) {
        const loading = this.$loading({
          lock: true,
          background: 'transparent'
        });
        this.$store
          .dispatch('theme/setColor', value)
          .then(() => {
            loading.close();
          })
          .catch((e) => {
            loading.close();
            this.$message.error(this.$t('common.loadFail'));
          });
      },
      /* 切换暗黑模式 */
      changeDarkMode(value) {
        this.$store.dispatch('theme/setDarkMode', value);
      },
      /* 切换色弱模式 */
      changeWeakMode(value) {
        this.$store.dispatch('theme/setWeakMode', value);
      },
      /* 设置主页包含的组件名称 */
      setHomeComponents(components) {
        this.$store.dispatch('theme/setHomeComponents', components);
      },
      /* 菜单路由国际化对应的名称 */
      i18n(path, key /*, menu*/) {
        // 参数三menu即原始菜单数据, 如果需要菜单标题多语言数据从接口返回可用此参数获取对应的多语言标题
        // 例如下面这样写, 接口的菜单数据为{path: '/system/user', titles: {zh: '用户管理', en: 'User'}}
        // return menu ? menu.titles[this.$i18n.locale] : null;
        const k = 'route.' + key;
        const title = this.$t(k);
        return title === k ? null : title;
      },
      /* 切换语言 */
      changeLanguage(lang) {
        this.$i18n.locale = lang;
        this.$store.commit('SET_LANGUAGE', lang);
      }
    }
  };
</script>
